<ng-template #filtersContent>
  <div class="p-grid">
    <div class="p-col-12" *ngIf="filterType !== 'COVERAGE_REPORT'">
      <p-fieldset legend="Content">
        <div class="p-grid">
          <div class="p-col-8">
            <h5>Timeframe</h5>
            <p-selectButton
              [options]="timeframes"
              [(ngModel)]="timeframeSelected"
              optionLabel="label"
              optionValue="value"
              (onChange)="onTimeframeChange($event)"
            >
            </p-selectButton>
          </div>
          <div class="p-col-4">
            <h5>Matching</h5>
            <p-selectButton
              [options]="matchTypes"
              [(ngModel)]="matchTypeSelected"
              optionLabel="label"
              optionValue="value"
              (onChange)="runAdvanceSearch()"
            >
            </p-selectButton>
          </div>
          <div class="p-col-6">
            <div *ngIf="timeframeSelected === 'CUSTOM'">
              <h5>Date range</h5>
              <p-calendar
                [showButtonBar]="true"
                [showIcon]="true"
                [(ngModel)]="fromDate"
                inputId="fromDate"
                placeholder="From date"
              >
              </p-calendar>
              <span class="m-l-15"></span>
              <p-calendar
                [showButtonBar]="true"
                [showIcon]="true"
                [(ngModel)]="toDate"
                inputId="toDate"
                placeholder="To date"
              >
              </p-calendar>
              <p-button
                icon="pi pi-filter"
                (click)="applyDateRage()"
                label="Set date range"
                class="p-mx-3 apply-button"
              >
              </p-button>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="p-col-12">
      <p-fieldset legend="Outlets">
        <div class="p-grid">
          <div class="p-col-6">
            <h5>My Outlets</h5>
            <p-selectButton
              [options]="outletFollowed"
              [(ngModel)]="outletFollowSelected"
              optionLabel="label"
              optionValue="value"
              (onChange)="runAdvanceSearch()"
            >
            </p-selectButton>
          </div>
          <div class="p-col-6" *ngIf="hasReportingAccess()">
            <h5>Outlet Groups</h5>
            <p-skeleton
              *ngIf="isLoadingGroups"
              width="100%"
              height="2.5rem"
            ></p-skeleton>
            <app-filter-multiselect
              *ngIf="!isLoadingGroups"
              testId="outlet-groups-filter"
              [options]="outletGroup"
              [(value)]="outletGroupSelected"
              optionLabel="label"
              optionValue="value"
              defaultLabel="All Groups"
              styleClass="filter-multiselect--groups"
              (selectionChange)="runAdvanceSearch()"
            ></app-filter-multiselect>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-6">
            <h5>Include Specific Outlets</h5>
            <span class="p-fluid">
              <p-autoComplete
                [forceSelection]="true"
                [(ngModel)]="selectedOutletsInclude"
                [suggestions]="filteredOutlets"
                (completeMethod)="findOutletsByName($event)"
                field="name"
                [multiple]="true"
                placeholder="Type outlets you want to include..."
                (onUnselect)="onUnselectOutlet($event)"
                (onSelect)="onSelectNewFilter($event)"
              >
              </p-autoComplete>
            </span>
          </div>
          <div class="p-col-6">
            <h5>Exclude Specific Outlets</h5>
            <span class="p-fluid">
              <p-autoComplete
                [forceSelection]="true"
                [(ngModel)]="selectedOutletsExclude"
                [suggestions]="filteredOutlets"
                (completeMethod)="findOutletsByName($event)"
                field="name"
                [multiple]="true"
                placeholder="Type outlets you want to exclude..."
                (onSelect)="onSelectNewFilter($event)"
              >
              </p-autoComplete>
            </span>
          </div>
        </div>
        <!-- Category label filters for Outlets -->
        <div class="p-grid" *ngIf="hasReportingAccess() && categories?.length > 0">
          <div class="p-col-6">
            <h6 class="category-label-title">Include Categories</h6>
            <app-filter-multiselect
              testId="outlet-include-categories-filter"
              [options]="categories"
              [(value)]="outletLabels"
              (selectionChange)="runAdvanceSearch()"
            ></app-filter-multiselect>
          </div>
          <div class="p-col-6">
            <h6 class="category-label-title">Exclude Categories</h6>
            <app-filter-multiselect
              testId="outlet-exclude-categories-filter"
              [options]="categories"
              [(value)]="excludeOutletLabels"
              (selectionChange)="runAdvanceSearch()"
            ></app-filter-multiselect>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="p-col-12 fieldset-spacing">
      <p-fieldset legend="Authors">
      <div class="p-grid">
        <div class="p-col-6">
          <h5>My Authors</h5>
          <p-selectButton
            [options]="authorFollowed"
            [(ngModel)]="authorFollowSelected"
            optionLabel="label"
            optionValue="value"
            (onChange)="runAdvanceSearch()"
          >
          </p-selectButton>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-6">
          <h5>Include Specific Authors</h5>
          <span class="p-fluid">
            <p-autoComplete
              [forceSelection]="true"
              [(ngModel)]="selectedAuthorsInclude"
              [suggestions]="filteredAuthors"
              (completeMethod)="findAuthorsByName($event)"
              field="name"
              [multiple]="true"
              placeholder="Type authors you want to include..."
              (onUnselect)="onUnselectAuthor($event)"
              (onSelect)="onSelectNewFilter($event)"
            >
            </p-autoComplete>
          </span>
        </div>
        <div class="p-col-6">
          <h5>Exclude Specific Authors</h5>
          <span class="p-fluid">
            <p-autoComplete
              [forceSelection]="true"
              [(ngModel)]="selectedAuthorsExclude"
              [suggestions]="filteredAuthors"
              (completeMethod)="findAuthorsByName($event)"
              field="name"
              [multiple]="true"
              placeholder="Type authors you want to exclude..."
              (onSelect)="onSelectNewFilter($event)"
            >
            </p-autoComplete>
          </span>
        </div>
      </div>
      <!-- Category label filters for Authors -->
      <div class="p-grid" *ngIf="hasReportingAccess() && categories?.length > 0">
        <div class="p-col-6">
          <h6 class="category-label-title">Include Categories</h6>
          <app-filter-multiselect
            testId="author-include-categories-filter"
            [options]="categories"
            [(value)]="authorLabels"
            (selectionChange)="runAdvanceSearch()"
          ></app-filter-multiselect>
        </div>
        <div class="p-col-6">
          <h6 class="category-label-title">Exclude Categories</h6>
          <app-filter-multiselect
            testId="author-exclude-categories-filter"
            [options]="categories"
            [(value)]="excludeAuthorLabels"
            (selectionChange)="runAdvanceSearch()"
          ></app-filter-multiselect>
        </div>
      </div>
    </p-fieldset>
  </div>
</div>
</ng-template>

<ng-container *ngIf="embedded; else advancedSearchDialog">
  <div class="advanced-search-embedded">
    <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
  </div>
</ng-container>

<ng-template #advancedSearchDialog>
  <p-dialog
    [dismissableMask]="true"
    header="Advanced Search Options"
    [(visible)]="showFilters"
    [style]="{ width: '70vw', maxWidth: '1100px' }"
    [baseZIndex]="10000"
    [modal]="true"
    (onHide)="onClose()"
  >
    <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
    <ng-template pTemplate="footer">
    <p-button
      pRipple
      icon="pi pi-times"
      (click)="onCancelFilters()"
      label="Cancel"
      styleClass="p-button-raised p-button-secondary p-button-text"
    ></p-button>
    <p-button
      pRipple
      icon="pi pi-check"
      (click)="onApplyFilters()"
      label="Apply"
      styleClass="p-button-raised"
      class="footer-apply-button"
    ></p-button>
    </ng-template>
  </p-dialog>
</ng-template>
